<nav id="breadcrumb" aria-label="breadcrumb">
	<ol class="breadcrumb">
		<li *ngFor="let crumb of breadcrumbs | async; last as isLast" class="breadcrumb-item" [class.active]="isLast">
			<ng-container *ngIf="!isLast">
				<ng-container *ngIf="crumb.url !== '/authenticated/affaires'; else noLink">
					<a [routerLink]="[crumb.url]">
						<ng-template [ngTemplateOutlet]="breadcrumbItem" [ngTemplateOutletContext]="{ $implicit: crumb, isLast: isLast }">
						</ng-template>
					</a>
				</ng-container>
				<ng-template #noLink>
					<span style="pointer-events: none; cursor: default">
						<ng-template [ngTemplateOutlet]="breadcrumbItem" [ngTemplateOutletContext]="{ $implicit: crumb, isLast: isLast }">
						</ng-template>
					</span>
				</ng-template>
			</ng-container>

			<ng-container *ngIf="isLast">
				<ng-template [ngTemplateOutlet]="breadcrumbItem" [ngTemplateOutletContext]="{ $implicit: crumb, isLast: isLast }"> </ng-template>
			</ng-container>
		</li>
	</ol>
</nav>

<ng-template #breadcrumbItem let-item let-isLast="isLast">
	<span *ngIf="item.hasTranslationKey" [attr.id]="isLast ? 'breadcrumb-label' : null" style="color: #6e6e6e">
		{{ item.label | translate: item.labelParams }}
	</span>
	<span *ngIf="!item.hasTranslationKey" [attr.id]="isLast ? 'breadcrumb-label' : null">
		{{ item.label }}
	</span>
</ng-template>
